var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.params && _vm.params.data && _vm.params.data.status)?_c('v-chip',{attrs:{"label":"","depressed":"","small":"","color":_vm.getSupportStatusColorClass(_vm.params.data.status)}},[_vm._v(" "+_vm._s(_vm.params.data.verbose_status)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }